export default {"src":"/_next/static/media/arrow-up-yellow.7ade41b5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};